import { getStore } from '@/lib/localStore';

export function applyTheme(darkMode) {
  document.documentElement.classList.toggle('dark', !!darkMode);
}

export function initTheme() {
  const setting = getStore({ name: 'systemSetting' });
  const darkMode = !!setting?.darkMode;
  applyTheme(darkMode);
  return darkMode;
}
